import { dateDifference } from "./utils"

const template={
    accountOverviewData: {
        numberOfProjects: 0,
        totalScans: 0,
        vulnerabilitiesAddressed: 0,
        vulnerabilitiesIdentified: 0
    },
    exclusionUsage: {
        dates: {},
        sortedDates: []
    },
    projectsData:{
        projects: []
    },
    projectsStats: {
        topPerforming: [],
        leastPerforming: []
    },
    projectsUsage: {
        dates: {},
        sortedDates: []
    }
}

class MetricsDataFormatter {
    format(rawData) {
        try{
            const data = JSON.parse(JSON.stringify(rawData))
            const metrics = JSON.parse(JSON.stringify(template))
            console.log(data)

            metrics.projectsData.projects = data.projects
            
            metrics.accountOverviewData.numberOfProjects = data.projects.length
            for (const project of metrics.projectsData.projects) {
                this.manipulateProjectName(project)
            }
            this.computeProjectsStatistics(metrics.projectsData.projects)

            this.sortByPerformanceScore(metrics.projectsData.projects)
            metrics.projectsStats.topPerforming = this.calculateTopPerforming( metrics.projectsData.projects, 3)
            metrics.projectsStats.leastPerforming = this.calculateLeastPerforming( metrics.projectsData.projects, 3)
            metrics.projectsUsage = this.processProjectsUsage(metrics.projectsData.projects)
            metrics.exclusionUsage = this.processExclusionUsage(metrics.projectsData.projects)
    
            if (data.totalScans>=0) metrics.accountOverviewData.totalScans = data.totalScans
            else metrics.accountOverviewData.totalScans = data.projects.reduce((scans, project)=>scans+=project.scans.length, 0)
            if (data.vulnerabilitiesAddressed>=0) metrics.accountOverviewData.vulnerabilitiesAddressed = data.vulnerabilitiesAddressed
            else metrics.accountOverviewData.vulnerabilitiesAddressed = data.projects.reduce((addressed, project)=>addressed+=project.vulnerabilitiesAddressed,0)
            if (data.vulnerabilitiesIdentified>=0) metrics.accountOverviewData.vulnerabilitiesIdentified = data.vulnerabilitiesIdentified
            else metrics.accountOverviewData.vulnerabilitiesIdentified = data.projects.reduce((identified, project)=>identified+=project.vulnerabilitiesIdentified,0)
            return metrics
        }
        catch(e){
            console.log(e)
            throw e
        }

    }

    manipulateProjectName(project){
        const processedName = window.splitName(project.projectUrl)
        project.nameFront = processedName.length > 1 ? processedName[0] : ""
        project.nameTail = processedName.length > 1 ? processedName[1] : processedName[0]
    }

    computeProjectsStatistics(projects){
        projects.map((project) => {
        
          const { scans } = project
          if(scans.length <= 1) {
            project.performanceScore = 0
            
            return project
          }
          project.deltaSecurityScore = scans.at(-1).securityScore - scans[0].securityScore
          project.deltaVulns =  scans[0].vulnerabilityCount - scans.at(-1).vulnerabilityCount
          project.performanceScore = project.deltaSecurityScore * 1000 + project.deltaVulns
          return project
        })
    }

    sortByPerformanceScore(projects){
        projects.sort((a, b) => b.performanceScore - a.performanceScore)
    }
    calculateTopPerforming(projects) {
        return projects.slice(0,3).filter(({performanceScore}) => performanceScore > 0 )
    }

    calculateLeastPerforming(projects) {
        return projects.slice(-3).filter(({performanceScore}) => performanceScore < 0 ).reverse()
    }

    processProjectsUsage(projects){
        const projectsUsage = { dates: {}, sortedDates: []}
        for(let i = 0; i < projects.length; i++) {
            const project = projects[i]
            for(let j = 0; j < project.scans.length; j++) {
                const scan = project.scans[j]
                const date = scan.timestamp.split(" ")[0]
                if(!projectsUsage.dates[date]) projectsUsage.dates[date] = { timestamp: scan.timestamp, totalScans: 0, totalProjects: 0 }
                if(!j) projectsUsage.dates[date].totalProjects += 1
                projectsUsage.dates[date].totalScans += 1
            }
        }
        projectsUsage.sortedDates = Object.keys(projectsUsage.dates)
        projectsUsage.sortedDates.sort((a, b) => new Date(a) - new Date(b))
        for(let i = 1; i < projectsUsage.sortedDates.length; i++) {
            const dates = projectsUsage.dates
            const prevDateKey = projectsUsage.sortedDates[i-1]
            const dateKey = projectsUsage.sortedDates[i]
            dates[dateKey].totalScans += dates[prevDateKey].totalScans
            dates[dateKey].totalProjects += dates[prevDateKey].totalProjects 
        }
        return projectsUsage
    }
    
    groupProjectsUsageByDays(projectsUsage, days){
        const grouped = {}
        let prevKey;
        for(let i = 0; i < projectsUsage.sortedKeys.length; i++) {
            const key = projectsUsage.sortedKeys[i]
            if(i === 0 || i === projectsUsage.sortedKeys.length - 1 || dateDifference(prevKey, key) >= days) {
              grouped[key] = projectsUsage[key]
              prevKey = key
              continue
            }
        }
        grouped.sortedKeys = Object.keys(grouped)
        return grouped
    }
    processExclusionUsage(projects){
        const exclusionUsage = { dates: {}, sortedDates: []}
        for(let i = 0; i < projects.length; i++) {
            const exclusions = projects[i].remediations.vulnerabilities
            for(let j = 0; j < exclusions.length; j++) {
                const date = exclusions[j].fixedWhen.split(" ")[0]
                if(date in exclusionUsage.dates) {
                    exclusionUsage.dates[date].exclusions.push(exclusions[j])
                } else {
                    exclusionUsage.dates[date] = {}
                    exclusionUsage.dates[date].exclusions = [exclusions[j]]
                    exclusionUsage.dates[date].totalExclusions = 0
                }
            }
        }
        exclusionUsage.sortedDates = Object.keys(exclusionUsage.dates)
        exclusionUsage.sortedDates.sort((a, b) => new Date(a) - new Date(b))
        for(let i = 1; i < exclusionUsage.sortedDates.length; i++) {
            const dates = exclusionUsage.dates
            const date = exclusionUsage.sortedDates[i]
            const prevDate = exclusionUsage.sortedDates[i-1]
            if(i == 1) dates[prevDate].totalExclusions = dates[prevDate].exclusions.length
            dates[date].totalExclusions = dates[prevDate].totalExclusions + dates[date].exclusions.length
        }
        return exclusionUsage
    }
}

export default MetricsDataFormatter